module.exports = __webpack_public_path__ + "img/icon_gasto.0f5b1746.svg";